import { useState, useEffect, useRef } from "react";
import moment from "moment";
import InputDate from "../../components/form/InputDate";
import Select from "../../components/form/select/Select";
import ModalDefault from "../../components/ModalDefault";
import api from "../../services/api";
import message from "../../services/message";
import axios from "axios";
import { Container } from "../../styles/layout";
import {
  IconAdd,
  IconArrow,
  IconDetails,
  IconEdit,
  IconFilter,
  IconRemove,
} from "../../components/layout/Svgs";

import {
  HeaderPonto,
  SectionFilterPonto,
  SectionTablePonto,
  SectionDetailsPonto,
  SectionRegisterPonto,
  ContainerPonto,
} from "./styles";
import ButtonDownload from "../../components/form/ButtonDownload/ButtonDownload";
import { ContainerModal, SectionModal } from "../../components/layout/styles";
import Input from "../../components/form/input/Input";


export default function ContratosListar() {

  const [load, setLoad] = useState(false);
  const [modal, setModal] = useState(false);

  const [selectedFile, setSelectedFile] : any = useState(null);
  const fileInputRef : any= useRef(null);

  const [contratos, setContratos] = useState([]);
  const [newContrato, setNewContrato] = useState({
    contratoId:null,
    clienteId:null,
    tipoPagamentoId:null,
    nome:'',
    arquivo:'',
    status:'ativo'
  });

  const [clientes, setClientes] = useState([]);
  const [tiposPagamento, setTiposPagamento] = useState([])

  useEffect(() => {
    getContratos()
    getClientes()
    getTiposPagamento()

    if (selectedFile) {
      handleUpload();
    }

  }, [selectedFile])


  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    // Atualiza o estado com o arquivo selecionado
    await setSelectedFile(event.target.files && event.target.files[0]);
  };


  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  const handleUpload = async () =>  {

    // Verifica se um arquivo foi selecionado
    if (!selectedFile) {
      console.log("Nenhum arquivo selecionado");
      return;
    }

    // Cria um objeto FormData para envolver o arquivo
    const formData = new FormData();
    formData.append('file', selectedFile);

    // Adiciona os headers necessários
    const headers = {
      Authorization: 'eyJhbGciOiJIUzI1NiJ9.Z3VpbGhlcm1lQHRyb3BhLmRpZ2l0YWx8fDIwMjQtMDEtMzBUMTc6NDE6MjQuNDIzWg.kOgosOkVSVyj05bqirzFLA29o7b8wYbIC9GKz-HDI0Q',
      Destination: 'tropafinanceiro',
    };

    try {
      // Envia a solicitação usando o Axios
      const response = await axios.post('https://bucket.backendtropa.com.br/upload', formData, {
        headers,
      });

      setNewContrato({
        arquivo:response?.data?.arquivo,
        contratoId:newContrato.contratoId,
        clienteId:newContrato.clienteId,
        tipoPagamentoId:newContrato.tipoPagamentoId,
        nome:newContrato.nome,
        status:'ativo'
      })

      console.log(newContrato)

      // Limpa o estado para permitir novos uploads
      //setSelectedFile(null);
    } catch (error) {
      console.error('Erro no upload:', error);
    }
  };

  const handleChooseFile = () => {
    // Aciona o clique no input file quando o botão personalizado é clicado
    if(fileInputRef?.current){
      fileInputRef?.current!.click();
    }
    
  };


  async function getContratos(){
    try{
      let response : any =  await api.get(`/contrato`)
      setContratos(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function getClientes(){
    try{
      let response : any =  await api.get(`/cliente`)
      setClientes(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function getTiposPagamento(){
    try{
      let response : any =  await api.get(`/tipo-pagamento`)
      setTiposPagamento(response.data)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function resetContrato(){
    setNewContrato({
      contratoId:null,
      clienteId:null,
      tipoPagamentoId:null,
      nome:'',
      arquivo:'',
      status:'ativo'
    })

    setModal(!modal)
  }

  function handleOnChangeNewContrato(name: string, value: string) {
    if (value) {
      setNewContrato({ ...newContrato, [name]: value });
    } else {
      setNewContrato({ ...newContrato, [name]: ''});
    }
  }

  async function editarContrato(id?: any) {
    try{
      if(id){
        let response = await api.get(`/contrato/${id}`)
        setNewContrato(response.data)
      }else{
        resetContrato()
      }
      
      setModal(true);
    } catch(error: any) {
      message.error(String(error?.response?.data?.message));
    }
  }

  async function saveContrato(e:any){
    try{
      e.preventDefault();
      let response : any
      if(newContrato.contratoId){
        response = await api.put(`/contrato/${newContrato.contratoId}`,newContrato)
        message.success(`Contrato Editado com Sucesso.`)
      }else{
        response = await api.post(`/contrato`, newContrato)
        message.success(`Contrato Criado com sucesso`)
      }
      await getContratos()
      resetContrato()
      setModal(!modal)
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  async function excluirContrato(id:number){
    try{
      let response : any = await api.delete(`/contrato/${id}`)
      getContratos()

      message.success(`Contrato Excluido com Sucesso.`)
    
    }catch(error:any){
      message.error(String(error?.response?.data?.message));
    }
  }

  return (
    <Container>
      <HeaderPonto>
        <h1 className="titlePonto">Contratos</h1>
        <button
          style={{ margin: "0px", width: "100px", letterSpacing: "1px",verticalAlign:'middle' }}
          className="btn btn-primary"
          onClick={() => editarContrato(null)}
        > 
          Adicionar 
          <i className="fa-solid fa-plus"></i>
        </button>
      </HeaderPonto>

      

      <SectionTablePonto>
        <table className="default">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Cliente</th>
              <th>Arquivo</th>
              <th>Tipo de Pagamento</th>
              <th>Editar</th>
              <th>Remover</th>
              
            </tr>
          </thead>

          <tbody>

            { contratos && contratos.length > 0 &&
              contratos.map((row:any, key:any) =>(
                <tr key={key}>
        
                  <td>{row.nome}</td>
                  <td>{row?.cliente?.nome}</td>
                  <td>{row.arquivo && <a href={row.arquivo} target="_blank" className="btn " style={{justifyContent:'left'}}> <i className="fa fa-download" ></i></a>}</td>
                  <td>{row?.tipoPagamento?.tipo}</td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => editarContrato(row.contratoId)}
                    >
                      <IconEdit />
                    </button>
                  </td>
                  <td>
                    <button
                      className="btn"
                      onClick={() => excluirContrato(row.contratoId)}
                    >
                      <IconRemove />
                    </button>
                  </td>
                </tr>
              ))
            }
          
          </tbody>
        </table>
      </SectionTablePonto>
      <ModalDefault
        id="modalDefault"
        onClose={() => {resetContrato()}}
        visible={modal}
      >
        <ContainerModal>
            <SectionModal>
              <h1>Editar / Adicionar - Contratos</h1>
              <form onSubmit={saveContrato}>
                <div className="field">
                  <h4>Nome</h4>
                  <div className="input">
                    <Input type="text" name="nome" value={newContrato?.nome} onChange={handleOnChangeNewContrato}/>
                  </div>
                </div>

                <div className="field">
                  <h4>Cliente</h4>
                  <div className="input">
                    <Select name="clienteId" onChange={handleOnChangeNewContrato} value={newContrato?.clienteId ? newContrato.clienteId : ''}>
                      <option value="">Selecione aqui...</option>
                      { clientes && clientes.length > 0 &&
                          clientes.map((row:any, key:any) =>(
                            <option key={key} value={row.clienteId}>{row.nome}</option>
                        ))
                      }
                    </Select>
                  </div>
                </div>

                <div className="field">
                  <h4>Tipo de Pagamento</h4>
                  <div className="input">
                    <Select name="tipoPagamentoId" onChange={handleOnChangeNewContrato} value={newContrato?.tipoPagamentoId ? newContrato.tipoPagamentoId : ''}>
                      <option value="">Selecione aqui...</option>
                      { tiposPagamento && tiposPagamento.length > 0 &&
                          tiposPagamento.map((row:any, key:any) =>(
                            <option key={key} value={row.tipoPagamentoId}>{row.tipo}</option>
                        ))
                      }
                    </Select>
                  </div>
                </div>

                <div className="field">
                  <h4>Arquivo</h4>
                  <div className="input">

                    
                    <div>
                      <input type="file" style={{ display: 'none' }} ref={fileInputRef} onChange={handleFileChange} />
                      <button style={{ textAlign: 'center' }} type="button" className="btn btn-success-outline" onClick={handleChooseFile}>Escolher Arquivo</button>
                      {selectedFile && newContrato?.arquivo  &&(
                        <div>
                          <p>Arquivo selecionado: {selectedFile?.name}</p>
                          <button className="btn btn-success" onClick={handleRemoveFile}>Remover</button>
                        </div>
                      )}
                    </div>


                  </div>
                </div>

                <div className="actions">
                  <button type="submit" className="btn btn-success">Salvar</button>
                  <button type="button" onClick={() => resetContrato()} className="btn btn-danger">Voltar</button>
                </div>
              </form>
            
            </SectionModal>
              <button
                className="buttonClosePreview"
                onClick={() => resetContrato()}
              >
                <IconRemove width="22px" height="22px" />
                Fechar modal
              </button>
          </ContainerModal>
        </ModalDefault>
    </Container>
  );
}
